import { __module as s } from "./ghl-ui.es1708.js";
import { i as v } from "./ghl-ui.es1541.js";
import { t as x } from "./ghl-ui.es1631.js";
import { r as O } from "./ghl-ui.es1637.js";
import { s as g } from "./ghl-ui.es1706.js";
(function(i, r) {
  var t = v.default;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = m;
  var l = t(x), n = t(O), f = t(g);
  function m(d) {
    (0, n.default)(1, arguments);
    var a = (0, l.default)(d), e = a.getUTCFullYear(), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(e + 1, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var p = (0, f.default)(u), o = /* @__PURE__ */ new Date(0);
    o.setUTCFullYear(e, 0, 4), o.setUTCHours(0, 0, 0, 0);
    var T = (0, f.default)(o);
    return a.getTime() >= p.getTime() ? e + 1 : a.getTime() >= T.getTime() ? e : e - 1;
  }
  i.exports = r.default;
})(s, s.exports);
var E = s.exports;
export {
  E as g
};
